var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeContext } from './themeContext';
export function ThemeProvider(props) {
  var children = props.children,
      _props$scheme = props.scheme,
      scheme = _props$scheme === void 0 ? 'light' : _props$scheme,
      rootTheme = props.theme,
      _props$tone = props.tone,
      tone = _props$tone === void 0 ? 'default' : _props$tone;

  var rootColor = rootTheme.color,
      restTheme = __rest(rootTheme, ["color"]);

  var colorScheme = rootColor[scheme] || rootColor.light;
  var color = colorScheme[tone] || colorScheme.default;
  var theme = {
    sanity: Object.assign(Object.assign({}, restTheme), {
      color: color
    })
  };
  return React.createElement(ThemeContext.Provider, {
    value: {
      theme: rootTheme,
      scheme: scheme,
      tone: tone
    }
  }, React.createElement(StyledThemeProvider, {
    theme: theme
  }, children));
}